export default __webpack_public_path__ + "static/media/UP.982f21cc.svg";